export const multiplyBy = (value: number | null | undefined, factor: number): number | undefined => {
    if (value === null || value === undefined) {
        return undefined;
    }
    return value * factor;
};
